import { render } from "./MoreActionsMenu.vue?vue&type=template&id=d1b51cac&scoped=true"
import script from "./MoreActionsMenu.vue?vue&type=script&lang=js"
export * from "./MoreActionsMenu.vue?vue&type=script&lang=js"

import "./MoreActionsMenu.vue?vue&type=style&index=0&id=d1b51cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b51cac"]])

export default __exports__